import { ShieldCheck } from "lucide-react";

// "No-Surprise Price Guarantee" callout — styled like the green "What's next?" box.
export function PriceGuarantee({ testid = "price-guarantee" }) {
  return (
    <div className="rounded-xl bg-green-50 border border-green-200 px-3 py-2.5 flex items-start gap-2.5" data-testid={testid}>
      <ShieldCheck className="w-5 h-5 text-[#207024] shrink-0 mt-0.5" aria-hidden="true" />
      <div className="leading-snug">
        <p className="text-sm font-bold text-zinc-900">Our No-Surprise Price Guarantee</p>
        <p className="text-xs text-zinc-700">The price you see is the price you pay. It only changes if you request changes.</p>
      </div>
    </div>
  );
}
